var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import './approval-item-card.css';
import { Card } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { any, eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { formatCurrency } from '../util/format-currency';
import ApprovalItemCardAPI from './approval-item-card-api';
let ApprovalItemCard = class ApprovalItemCard extends Component {
    render() {
        const { itemName, amount, value, unitType, stockLocale, costCenter, type, materialCode, lastPurchaseValue, } = this.props;
        const numValue = Number(value) || 0;
        const numLastPurchaseValue = Number(lastPurchaseValue) || 0;
        const totalValue = numValue * Number(amount);
        return (React.createElement(Card, { transparent: false, className: "approval-item-card", uuid: generateUUID(), selectionType: SelectionType.NONE },
            React.createElement("div", { className: "approval-item-card__info" },
                React.createElement("div", { className: "approval-item-card__info-item" }, `${materialCode} - ${itemName}`),
                React.createElement("div", { className: "approval-item-card__info-amount" },
                    MessageService.translate('approvals.item.amount'),
                    ": ",
                    amount),
                React.createElement("div", { className: "approval-item-card__info-value" },
                    MessageService.translate('approvals.item.unit-price'),
                    ": ",
                    formatCurrency(numValue)),
                type == 'O' || type == 'S' ?
                    React.createElement("div", { className: "approval-item-card__info-value" },
                        MessageService.translate('approvals.item.total-item'),
                        ": ",
                        formatCurrency(totalValue)) : null,
                numLastPurchaseValue > 0 ?
                    React.createElement("div", { className: "approval-item-card__info-value" },
                        MessageService.translate('approvals.item.last-purchase-value'),
                        ": ",
                        formatCurrency(numLastPurchaseValue))
                    : null,
                React.createElement("div", { className: "approval-item-card__info-unit" },
                    MessageService.translate('approvals.item.unit'),
                    ": ",
                    unitType),
                costCenter ? React.createElement("div", { className: "approval-item-card__info-cost" },
                    MessageService.translate('approvals.costcenter'),
                    ": ",
                    costCenter) : null,
                stockLocale ? React.createElement("div", { className: "approval-item-card__info-stock" },
                    MessageService.translate('approvals.stocklocale'),
                    ": ",
                    stockLocale) : null)));
    }
};
ApprovalItemCard.propTypes = {
    itemName: string,
    amount: any,
    value: any,
    unitType: string,
    costCenter: string,
    stockLocale: string,
    type: string,
    materialCode: number,
    lastPurchaseValue: number,
    onClick: eventListener,
};
ApprovalItemCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ApprovalItemCardAPI })
], ApprovalItemCard);
export default ApprovalItemCard;
//# sourceMappingURL=approval-item-card.js.map